import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../Component/Button";
import Footer from "../Component/Footer";
// import GreyLine from "../Component/GreyLine";
import Heading from "../Component/Heading";
import NavText from "../Component/NavText";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import {
  apiUrl,
  catUID,
  createOrder,
  handleCoins,
  handleCoupon,
  rzpKey,
  themecolor,
} from "../Utils/constants";
import moment from "moment";
import GreyLine from "../Component/GreyLine";
import { useForm } from "react-hook-form";
import {
  TransactionAction,
  coinsDetailAction,
  couponDetailAction,
  restCouponDetailAction,
} from "../Component/Redux/Feature/UrlSlice";
import Popup2 from "../Component/Popup2";
import GstPopup from "../Component/GstPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faArrowRight,
  faCheck,
  faCheckCircle,
  faIdBadge,
  faXmark
} from "@fortawesome/free-solid-svg-icons";
import {
  gstnAction,
  gstnameAction,
} from "../Component/Redux/Feature/EmailSlice";
import Switch from "react-switch";
import { getContentData } from "../Utils/content";
import Drawer from "../Component/Drawer/Drawer"
import Coupon from "../Component/Coupon";
import ApplyCouponView from "../Component/ApplyCouponView/ApplyCouponView";
import Modal from "../Component/Modal/Modal";
import AppliedCouponView from "../Component/AppliedCouponView/AppliedCouponView";

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}
const PaymentContentNew = ({ appname }) => {
  const [couponsuccess, setCouponSuccess] = useState(false);

  const [couponcost, setCouponCost] = useState(false);
  const [couponerror, setCouponError] = useState(false);
  const [couponcode, setCouponCode] = useState(null);
  const [couponid, setCouponId] = useState(null);
  const [ogvalues, setOg] = useState(null);

  const [showPopup2, setShowPopup2] = useState(false);

  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedDone, setIsCheckedDone] = useState(false);

  const [OpenGst, setOpenGst] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const [allCoupons, setAllCoupons] = useState();
  const [couponsLoading, setCouponsLoading] = useState(false);
  const [couponsError, setCouponsError] = useState();

  const [applyCouponErr, setApplyCouponErr] = useState();
  const [applyCouponLoading, setApplyCouponLoading] = useState();

  const [params, setParams] = useState();

  const { selectedCategory, selectedBranch } = useSelector(
    (state) => state.Categories
  );

  const [modalOpen, setModalOpen] = useState(false);
  const [couponDetails, setCouponDetails] = useState(null);


  const togglePopup2 = () => {
    setShowPopup2(!showPopup2);
  };

  const navigate = useNavigate();
  const catlocation = useLocation()
  const [categoryId, setCategoryId] = useState(null);  

  const storesel = useSelector((state) => state);
  const planNameredux = storesel.UrlData.planName;
  const emailParam = storesel.emailData?.emailStored;
  const gstnRedux = storesel.emailData?.gstn;
  const gstnameRedux = storesel.emailData?.gstname;
  const appParam = storesel?.emailData?.appStatus;
  

  const DataStore = storesel.UrlData.userDetails;
  
  const token = storesel?.emailData?.token;

  const rewardObjectRedux = storesel.UrlData.rewardsDetails;

  const coinsValue = isChecked ? rewardObjectRedux?.coins_Value : 0;

  const myObject = storesel.UrlData.userDetails;
  const continuosData = storesel?.emailData?.checkoboxCheck;
  let keys = Object.keys(myObject);

  if (myObject.Discount > 0) {
    keys = ["Amount", "Discount", "Taxes", "Total Amount"];
  } else {
    keys = ["Amount", "Taxes", "Total Amount"];
  }
  


  const handleResize = () => {
    setIsSmallScreen(window.innerWidth < 600); // Adjust the breakpoint as needed
  };

  // Set up event listener for window resize
  useEffect(() => {
    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };

  }, []);


  const fetchCoupons = async (token, amount, plain_id, branch_id, user_id, sessionid) => {
    setCouponsLoading(true);
    setCouponError(null);

    console.log("TOKEN IN FN ", token);
    const uid = await catUID(catlocation.pathname)
    setCategoryId(uid)

    setParams({
      category_id : uid,
      cart_amount : amount,
      payment_type: "new",
      plan_id: plain_id,
      session_id: sessionid,
      branch_id: branch_id,
      user_id: user_id
    })

    try {

    axios.get(apiUrl + '/get_all_coupons',  {
        params: {
          category_id : uid,
          cart_amount : amount,
          payment_type: "new",
          // plan_id: plain_id,
          session_id: sessionid,
          branch_id: branch_id,
          user_id, user_id
        },
        headers: token ? { "Authorization": `Bearer ${token}`} : {},
      
    }).then(res => {
      setCouponsLoading(false);
      setCouponError(null);

      console.log("Coupons RES", res?.data)
      setAllCoupons(res?.data?.data);
    }). catch(err => {
      setCouponsLoading(false);
      setCouponError(err?.response?.data?.message);

      console.error("Error fetching coupons!!!!");
    })

    }

    catch(err) {
      setCouponsLoading(false);
      setCouponError(err?.response?.data?.message);

      console.error("Error fetching coupons!!!!");
    }

  }

  useEffect(() => {
    if(myObject) {
      fetchCoupons(token, myObject?.Amount, myObject?.planid, myObject?.branchid, myObject?.userid, myObject?.sessionid)
    }
  }, [token])

  useEffect(() => {
    setOg({
      Amount: DataStore.Amount,
      Total: DataStore["Total Amount"],
      Taxes: DataStore.Taxes,
    });

   
    // dispatch(
    //   couponDetailAction({
    //     couponcost: 0,
    //     Discount: 0,
    //     Taxes: DataStore.ogTaxes,
    //     total: DataStore.ogTotal
    //   })
    // );
  }, []);

  const handleSwitchChange = async () => {
    setIsChecked((prevChecked) => !prevChecked);
  };

  const getCoinResult = async () => {
    // alert(coinsValue);

    const coinResult = await handleCoins(
      couponcode,
      DataStore.Amount,
      DataStore.planid,
      ogvalues,
      DataStore,
      coinsValue
    );

    console.log(coinResult,DataStore,"coinResult243")
    if (coinResult.error === null) {

        dispatch(couponDetailAction(coinResult.data));
        setIsCheckedDone(isChecked);

      const params = {
      category_id : categoryId,
      cart_amount : myObject?.Amount,
      payment_type: "new",
      plan_id: myObject?.planid,
      branch_id: myObject?.branchid,
      user_id: myObject?.userid
    }

    if(couponDetails) {
      
        setTimeout(async () => {
          const res = await handleCoupon(couponDetails?.couponcode, myObject?.Amount, myObject?.planid, ogvalues, DataStore, coinsValue, params, token)

    //       if(!res?.data?.notFoundErr)
            // handleCouponCodeResponse(res);

        }, 0)
    }

    }

  };

  useEffect(() => {

    getCoinResult();

  }, [isChecked]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const onSubmit = async (data) => {};

  const createOrderFunc = async () => {
    var bodyData2 = {
      planid: DataStore.planid,
      sessionid: DataStore.sessionid,
      contact: DataStore.phone.toString(),
      basecost: DataStore.Amount,
      sumcost: DataStore["Total Amount"],
      taxcost: DataStore.Taxes,
      taxpercent: DataStore.taxpercent,
      amountpaid: " ",
      pendingamount: " ",
      couponcost: couponcost,
      couponcode: couponcode,
      couponid: couponid,
      tdspercent: " ",
      tdscost: " ",
      invoiceid: " ",
      gstn: gstnRedux ? gstnRedux : "",
      istrial: DataStore.isTrial,
      gstname: gstnameRedux ? gstnameRedux : "",
      billto: " ",
      paymentmode: "online",
      paymentmethod: " ",
      status: "attempting",
      statusmsg: "on cost breakdown page",
      billdate: "0000-00-00",
      startdate: DataStore.startdate,
      userid: DataStore.userid,
      continous: continuosData ? continuosData : 0,
      referral_points: rewardObjectRedux?.coins_Count,
      referral_amount: coinsValue,
    };

    try {
      const orderData = await createOrder(bodyData2, ogvalues, DataStore);

      setApiStatus("success");
      dispatch(
        TransactionAction({
          orderid: orderData.id,
          transactionid: orderData.transactionid,
          transactionuid: orderData.transactionuid,
        })
      );
      // navigate(`/${planNameredux}/payment`);
    } catch (e) {
      if (
        e.response &&
        e.response.data.message === "You cannot buy this plan right now!!"
      ) {
        togglePopup2();
      }
      setApiStatus("error");
      setButtonClicked(false);
      console.log("Axios request error:", e);
    }
    setButtonClicked(false);
    setLoading(false);
  };

  useEffect(() => {
    setButtonClicked(true);
    setLoading(true);

    createOrderFunc();
  }, [couponcode, gstnRedux, gstnameRedux, isCheckedDone]);

  const handleCouponCodeResponse = (couponData) => {

    console.log("handleCouponCode Response ran!!!!", couponData);

    if (couponData.error === null) {
      dispatch(couponDetailAction(couponData?.data));
      setCouponCost(couponData?.data?.couponDetails[0]?.applicableDiscount);
      setCouponSuccess(true);
      setCouponError(false);
      setCouponCode(couponData?.data?.couponDetails[0]?.couponcode);
      setCouponId(couponData?.data?.couponDetails[0]?.uid);
      //   if (couponData.couponcost > 0) {
      //     setCouponSuccess(true);
      //     setCouponError(false);

    } else {

      dispatch(couponDetailAction(
        couponData.data
      ));

      setCouponError(couponData.error);
      setCouponCode(null);
      setCouponId(null);
      setCouponCost(false);
      setCouponSuccess(false);
    }
  }


  const clearCoupon = () => {
    dispatch(couponDetailAction(
      {
          couponcost: 0,
          Discount: 0,
          Taxes:
            parseInt(coinsValue) > 0
              ? Math.round(
                  ((ogvalues.Amount - parseInt(coinsValue)) *
                    DataStore.taxpercent) /
                    100
                )
              : DataStore.ogTaxes,
          total:
            parseInt(coinsValue) > 0
              ? Math.round(
                  ogvalues.Amount -
                    parseInt(coinsValue) +
                    ((ogvalues.Amount - parseInt(coinsValue)) *
                      DataStore.taxpercent) /
                      100
                )
              : DataStore.ogTotal,
          ogTaxes: DataStore.ogTaxes,
          ogTotal: DataStore.ogTotal,
          couponcode: null,
          couponid: null,
      }
    ));

   
    setCouponCode(null);
    setCouponId(null);
    setCouponCost(false);
    setCouponSuccess(false);
    setCouponDetails(null);
    setModalOpen(false);
  }

  // -----loading spinne state----
  const handleCouponCode = async (event) => {
    var target = document.getElementById("couponCode");
    const couponcode = target.value;
    const amountforcoupon = DataStore.Amount;
    const planidforcoupon = DataStore.planid;

    // try {
    const couponData = await handleCoupon(
      couponcode,
      amountforcoupon,
      planidforcoupon,
      ogvalues,
      DataStore,
      coinsValue
    );

    console.log(ogvalues,"ogvalues 441");

    if (couponData.error === null) {
      dispatch(couponDetailAction(couponData.data));
      setCouponCost(couponData.data.Discount);
      setCouponSuccess(true);
      setCouponError(false);
      setCouponCode(couponData.data.couponcode);
      setCouponId(couponData.data.couponid);
      //   if (couponData.couponcost > 0) {
      //     setCouponSuccess(true);
      //     setCouponError(false);
    } else {
      dispatch(couponDetailAction(couponData.data));
      setCouponError(couponData.error);
      setCouponCode(null);
      setCouponId(null);
      setCouponCost(false);
      setCouponSuccess(false);
    }
    // }
  };

  const [loading, setLoading] = useState(false);
  const [apiStatus, setApiStatus] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);
  const [emailParamsExists, setEmailFromParams] = useState(false);
  const [appParamExists, setAppParamExist] = useState(false);

  useEffect(() => {
    if (emailParam) {
      setEmailFromParams(true);
    }

    if (appParam) setAppParamExist(true);
  }, [emailParam, appParam]);

  const checkGstTick = (e) => {
    if (e.target.checked) {
      setOpenGst(true);
    } else {
      setOpenGst(false);
      dispatch(gstnAction(""));
      dispatch(gstnameAction(""));
    }
  };
  
  const PaymentFunc = async () => {
    setButtonClicked(true);
    setLoading(true);
    if (myObject["Total Amount"] > 0) {
      axios({
        method: "patch",
        url: apiUrl + "/updateTransaction/" + myObject.transactionid,
        data: { statusmsg: "user opened the razorpay popup" },
      })
        .then((response) => {
          setApiStatus("success");
        })
        .catch((error) => {
          setApiStatus("error");
        });

      if (!appParamExists) {
        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
          alert("Razorpay SDK failed to load. Are you online?");
          return;
        }
        const options = {
          key: rzpKey,
          currency: "INR",
          amount: myObject["Total Amount"],
          order_id: myObject.orderid,
          name: getContentData(appname).brandName + " - " + myObject.name,
          // name: "SweatFit wellness" + myObject.name,
          
          description: "",
          // image: getContentData(appname).payimage,
          image: '/pilatesLogo.png',
          theme: {
            // color: getContentData(appname).themecolor,
            color: 'black'
          },
          handler: function (response) {
            // alert(response.razorpay_payment_id);
            // alert(response.razorpay_order_id);
            // alert(response.razorpay_signature);
            if (response) {
              navigate(
                `/${selectedCategory}/${selectedBranch}/${planNameredux}/thank`
              );
            }
          },
          modal: {
            ondismiss: function () {
              // alert("hjhii");
              setButtonClicked(false);
              // var sendurl = axios({
              //   method: "patch",
              //   url:
              //     apiUrl+`/updateTransaction/` +
              //     myObject.transactionid +
              //     ``,
              // })
              var sendurl = axios({
                method: "patch",
                url:
                  apiUrl + `/updateTransaction/` + myObject.transactionid + ``,
                data: { statusmsg: "User closed the razorpay popup" },
              })
                .then((response) => {
                  console.log("");
                })
                .catch((error) => {
                  console.log("");
                });
            },
            // Boolean indicating whether pressing escape key
            // should close the checkout form. (default: true)
            escape: true,
            // Boolean indicating whether clicking translucent blank
            // space outside checkout form should close the form. (default: false)
            backdropclose: false,
          },
          prefill: {
            name: myObject.firstname,
            email: myObject.email,
            phone_number: myObject.phone,
          },
          notes: {
            transaction: myObject.transactionuid,
            startdate: myObject.startdate,
            plan: myObject.planid,
            use_coins: isChecked ? 1 : 0,
            customer: myObject.userid,
            session: myObject.sessionid,
            name: myObject["Plan Name"],
            branch: myObject.branchid,
            days: myObject.daystime,
            total: myObject["Total Sessions"],
            istrial: 0,
            email: myObject.email,
            firstname: myObject.firstname,
            continous: continuosData ? continuosData : 0,
          },
        };
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } else {
        const options = {
          key: rzpKey,
          currency: "INR",
          amount: myObject["Total Amount"],
          order_id: myObject.orderid,
          name: getContentData(appname).brandName + " - " + myObject.name,
          description: "",
          image: '/pilatesLogo.png',
          theme: {
            color: 'black',
          },
          prefill: {
            name: myObject.firstname,
            email: myObject.email,
            contact: myObject.phone,
          },
          notes: {
            transaction: myObject.transactionuid,
            startdate: myObject.startdate,
            plan: myObject.planid,
            customer: myObject.userid,
            session: myObject.sessionid,
            name: myObject["Plan Name"],
            branch: myObject.branchid,
            days: myObject.daystime,
            total: myObject["Total Sessions"],
            istrial: 0,
            email: myObject.email,
            firstname: myObject.firstname,
            continous: continuosData ? continuosData : 0,
          },
        };
        window.location.href = `${selectedCategory}/${selectedBranch}/${planNameredux}/payment?json=${JSON.stringify(
          options
        )}`;
      }
    } else {
      var bodyData = {
        firstname: myObject.firstname,
        email: myObject.email,
        customer: myObject.userid,
        plan: myObject.planid,
        session: myObject.sessionid,
        name: myObject["Plan Name"],
        days: myObject.daystime,
        base_amount: myObject.Amount,
        transaction: myObject.transactionuid,
        startdate: myObject.startdate,
        branch: myObject.branchid,
        total: myObject["Total Sessions"],
        istrial: myObject.isTrial,
      };

      axios({
        method: "post",
        url: apiUrl + "/buyTrialPlan",
        data: bodyData,
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => {
          setApiStatus("success");
          if (!emailParamsExists) {
            navigate(
              `/${selectedCategory}/${selectedBranch}/${planNameredux}/thank`
            );
          } else {
            window.location.href = `/${selectedCategory}/${selectedBranch}/${planNameredux}/thank`;
          }
        })
        .catch((error) => {
          setApiStatus("error");
        });
    }
    setLoading(false);
  };

  const formattedStartDate = moment(myObject["startdate"]).format(
    "DD MMM YYYY"
  );
  const formattedEndDate = moment(myObject["Expiry Date"]).format(
    "DD MMM YYYY"
  );


  if (categoryId === null) {
    return null; // Or return null if you don't want any loading text
  }
  return (
    // value: /^[a-zA-Z0-9']*$/g,
    <>
      <div className="home-content-container payment-content-container terms-condition-content start-content-container">
        <NavText
          currentPageText="Checkout"
          name={myObject.name}
          
          planname="Sweat Fit Wellness"
        />
        <Heading headingText="CHECKOUT" />

        {/* <GreyLine /> */}

        <div className="payment-list-div">
          <span className="plan-name-text">
            {myObject["Plan Name"]} | {myObject.name}
          </span>
          <br />
          <p className="payment-start-date-text">
            Class Pack : {myObject["Total Sessions"]}{" "}
            {myObject["Total Sessions"] > 1 ? `Session` : `Session`}
          </p>
          <p className="payment-start-date-text">
            Start Date : {formattedStartDate}
          </p>
          <p className="payment-start-date-text">
            End Date : {formattedEndDate}
          </p>

          {OpenGst && <GstPopup handleClose={() => setOpenGst(false)} />}
          <form
            className="Start-page-form payment-page-form "
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="gst-input-div">
              <label>I have a GST number</label>
              <input
                type="checkbox"
                checked={
                  gstnRedux !== undefined &&
                  gstnRedux !== null &&
                  gstnRedux !== "" &&
                  gstnameRedux !== undefined &&
                  gstnameRedux !== null &&
                  gstnameRedux !== "" &&
                  gstnRedux?.trim()?.length != 0 &&
                  gstnameRedux?.trim()?.length != 0
                    ? true
                    : false
                }
                onChange={checkGstTick}
              />
            </div>

            {gstnRedux &&
              gstnameRedux &&
              gstnRedux.trim().length != 0 &&
              gstnameRedux.trim().length != 0 && (
                <div className="show-gst-detail-div">
                  <div className="gst-done-icon">
                    <p>
                      <FontAwesomeIcon icon={faCheckCircle} />
                      <span>{gstnameRedux}</span>
                    </p>
                    <p>
                      <FontAwesomeIcon icon={faCheckCircle} />
                      <span>{gstnRedux}</span>
                    </p>
                  </div>
                  <p className="gst-edit-text" onClick={() => setOpenGst(true)}>
                    Edit
                  </p>
                </div>
              )}

            <div className="form-input confirmation-form">
              {/* <label className="coupon-lable" htmlFor="">
                Do you have coupon code?
              </label>
              <div className="confirmation-form-input-div">
                <input
                  className="coupon-input "
                  placeholder="Coupon code"
                  id="couponCode"
                  type="text"
                  defaultValue={DataStore.couponcode}
                  //   onClick={handleCouponCode}
                  {...register("coupon", {
                    pattern: {
                      // value: /^[a-zA-Z0-9_]*$/g,
                      value: /^[a-zA-Z0-9]*$/g,
                      message:
                        "Enter lowercase aphabet or number with no space or special character",
                    },
                  })}
                />
                <div
                  onClick={handleCouponCode}
                  className="coupon-appyly-button btn"
                >
                  Apply
                </div>
              </div> */}

              {/* {errors.coupon && (
                <span className="">{errors.coupon.message}</span>
              )} */}

              {/* {applyCouponErr && <span className="">{applyCouponErr}</span> } */}

              {couponsuccess && (
                <div className="flex justify-between applied-coupon-inpage">
                  <div className="flex justify-between flex-dir-col gap1">
                  <span className="success" style={{ color: "darkgreen" }}>
                    '{couponDetails?.couponcode}' COUPON APPLIED! 
                  </span>
                  <p className="flex align-items-center gapPt5"><FontAwesomeIcon style={{color: "green"}} icon={faCheckCircle}></FontAwesomeIcon> You will get ₹{DataStore.couponcost} OFF</p>
                </div>
                <button disabled={loading} className="clearCoupon" onClick={clearCoupon}><FontAwesomeIcon icon={faXmark} /> Remove</button>
                </div>
              )}
              {/* {couponerror && <span className="">{couponerror}</span>} */}
            </div>
            
            <button disabled={loading} className="applyCouponBtn" onClick={async() =>
                {
                //   if(isChecked) {
                    

                //   const coinResult = await handleCoins(
                //     couponcode,
                //     DataStore.Amount,
                //     DataStore.planid,
                //     ogvalues,
                //     DataStore,
                //     coinsValue
                //   );
              
                //   if (coinResult.error === null) {
                //     dispatch(couponDetailAction(coinResult.data));
                //   }
                // }

                  setTimeout(() => {
                   setDrawerOpen(true)
                  });
              
              }}>
             <p className="ApplyCouponTxt">Apply Coupon {allCoupons?.length > 0 ? (allCoupons?.length > 1 ? "("+allCoupons?.length +" coupons available)" : "("+allCoupons?.length +" coupon available)") : ""}</p> <FontAwesomeIcon style={{fontSize: "1.2rem"}} icon={faAngleRight}></FontAwesomeIcon>
            </button>

          </form>

          <GreyLine lineColour="custom-line" />

          {/*  */}

          {keys.map((value, index) => {
            console.log(value,'value839');
            console.log(myObject[value],'value839');
            return (
              <>
                <div className="payment-list-item">
                  <div className="payment-list-item-row">
                    <>
                      <p>{value}:</p>
                      <p className="payment-list-item-row-value">
                        {["Amount", "Taxes", "Total Amount"].includes(value)
                          ? "₹"
                          : ""}
                        {["Discount"].includes(value) ? "- ₹" : ""}
                        {myObject[value]}
                        {["Amount"].includes(value) && isCheckedDone ? (
                          <>
                            {" "}
                            <img
                              height={"15px"}
                              src="asset/Img/coin.png"
                              alt=""
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                    </>
                  </div>
                </div>
              </>
            );
          })}

          {rewardObjectRedux?.coins_Count &&
          rewardObjectRedux?.coins_Count != 0 ? (
            <div className="switch-parent-div show-gst-detail-div">
              <div className="img-label-switch-div">
                <img src="asset/Img/coin.png" alt="" />
                <label>
                  Use {rewardObjectRedux?.coins_Count} coins and save ₹
                  {rewardObjectRedux?.coins_Value}?
                </label>
              </div>
              <Switch
                checked={isChecked}
                disabled={loading}
                // onChange={(checked) => setIsChecked(checked)}
                onChange={handleSwitchChange}
                height={15}
                width={40}
                className="react-switch"
              />
            </div>
          ) : null}
          {!buttonClicked ? (
            <Button btnText="Pay Now" onClick={PaymentFunc} />
          ) : loading || apiStatus !== "success" ? (
            <Player
              autoplay
              loop
              src="asset/Img/spinner.json"
              style={{ width: "50px", height: "50px" }}
            >
              <Controls
                visible={false}
                buttons={["play", "repeat", "frame", "debug"]}
              />
            </Player>
          ) : (
            <Button btnText="Pay Now" onClick={PaymentFunc} />
          )}
        </div>

        <Footer />

        {showPopup2 && (
          <Popup2
            togglePopup2={togglePopup2}
            paratext={
              DataStore.isTrial === 1
                ? "You have already enrolled once for the trial of this plan."
                : "You are already enrolled in this plan. Please note that users cannot purchase a new plan until their current or upcoming plan has expired."
            }
            title="YOU CAN'T PURCHASE THIS PLAN!"
          />
        )}

       
      </div>

    <Drawer
    setDrawerOpen={setDrawerOpen}
    drawerOpen={drawerOpen}
    onCloseBool={true}
    shouldCloseDrawer={true}
    onClose={() => console.log("drawerclose")}
    position={isSmallScreen ? "bottom" : "right"}
    >
      <ApplyCouponView params={params} coupons={allCoupons} ogvalues={{
        Amount: DataStore.Amount,
        Total: DataStore["Total Amount"],
        Taxes: DataStore.Taxes,
        }}
        DataStore={DataStore} 
        coinsValue={coinsValue} 
        setDrawerOpen= {setDrawerOpen}
        handleCouponCodeResponse={handleCouponCodeResponse}
        setModalOpen = {setModalOpen}
        setCouponDetails={setCouponDetails}
        setCouponError={setCouponError}
        couponsError={couponerror}
        couponsLoading={couponsLoading}
        applyCouponErr={applyCouponErr}
        setApplyCouponErr={setApplyCouponErr}
        setApplyCouponLoading={setApplyCouponLoading}
        applyCouponLoading = {applyCouponLoading}
      /> 
    </Drawer>

    <Modal isOpen={modalOpen} setIsOpen={setModalOpen}>
     
     {!applyCouponLoading && <AppliedCouponView couponDetails={couponDetails} setModalOpen={setModalOpen} />}
      {applyCouponLoading && <div style={{background: "white", width: "300px", height: "300px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "1rem",  borderRadius: "1rem"}}>
        
        <div className="purple-spinner"></div>
        <p>Applying coupon...</p>
      </div>}
    </Modal>
    </>
  );
};

export default PaymentContentNew;
